import { configureStore } from "@reduxjs/toolkit";
import {
  FLUSH,
  PAUSE,
  PURGE,
  PERSIST,
  persistReducer,
  REHYDRATE,
  REGISTER,
} from "redux-persist";

import rootReducer, { ThunkExtraArg } from "./rootReducer";

export const configureAppStore = (
  addToast: ThunkExtraArg["addToast"],
  persistConfig: any,
) => {
  const persistedReducer = persistReducer(persistConfig, rootReducer);

  return configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        thunk: {
          extraArgument: { addToast },
        },
        serializableCheck: {
          ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
        },
      }),
  });
};

export type AppStore = ReturnType<typeof configureAppStore>;
export type AppDispatch = AppStore["dispatch"];

let store: AppStore;

export const initializeStore = (
  addToast: ThunkExtraArg["addToast"],
  persistConfig: any,
) => {
  store = configureAppStore(addToast, persistConfig);
  return store;
};

export const getStore = () => store;
